import React from 'react';
import './patients.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Pacientes'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
